module.exports = __webpack_public_path__ + "static/media/assurant.077a7bfe.webp";